import React, { Component } from 'react';

import CustomTable from '../../../shared/custom-table/components/custom-table';

class ActivitySummaryTable extends Component {
  render() {
    const { table } = this.props;

    return (
      <div className="activity-summary-container__table">
        <CustomTable table={table} />
      </div>
    );
  }
}

export default ActivitySummaryTable;



// WEBPACK FOOTER //
// ./src/app/main/dashboard/components/activity-summary-table.js